import { initSegmentedCodeInput } from './segmented_code_input';

export const initTwoFactorCodeInput = () => initSegmentedCodeInput({
  boxSelector: '.devise-form-two-factor-verification__code-input',
  continueButtonId: 'two-factor-continue',
  codeFieldId: 'two-factor-code-value',
});
